import Organization from "./organization";
import SignupUserStatus from "./signupUserStatus";

export default class SignupInvitation {
  public idSignupInvitation: number = 0;
  public idOrganization: number = 0;
  public email: string = "";
  public firstName: string = "";
  public lastName: string = "";
  public invitationDate: Date = new Date();
  public signupDate: Date | undefined = undefined;
  public signupUserStatus: SignupUserStatus = SignupUserStatus.Invited;
  public organization: Organization | undefined = undefined;

  // ui only
  public hasError: boolean = false;
}
